import { useContext, useState } from 'react';
import { ActionModal } from '../../../../../../components/Modal';
import React from 'react';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../types/translation/Translator';
import { Button, CancelButton } from '../../../../../../components/Button';
import { useToast } from '../../../../../../../providers/ToastProvider';
import BinConstraintInfoPane from '../Panes/BinConstraintInfoPane';
import { BinConstraintInput } from '../../../../../../../types/bin_constraints/binConstraint.input';
import { useRequest } from '../../../../../../../requests/common/requestHook';
import { BinConstraintRequest } from '../../../../../../../requests/binConstraint.request';
import { BinConstraintContext } from '../../../../../../../context/BinConstraintContext';
import { BinConstraint } from '../../../../../../../types/bin_constraints/binConstraint';

interface UpdateBinConstraintModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  item?: BinConstraint;
}

export default function UpdateBinConstraintModal({ open, setOpen, item }: UpdateBinConstraintModalProps) {
  const { showToast } = useToast();

  const { binConstraints, setBinConstraints } = useContext(BinConstraintContext);

  const [input, setInput] = useState<BinConstraintInput>(new BinConstraintInput(item));

  const [update, { loading }] = useRequest(BinConstraintRequest.update);

  const handleUpdate = async () => {
    const result = await update({ data: [input.forUpdate()] });
    if (!result) return;

    const constraint = result[0];
    binConstraints.set(constraint.id, new BinConstraint(constraint));
    setBinConstraints(new Map(binConstraints));
    setOpen(false);
  };

  const footer = (
    <div className='flex justify-end gap-2'>
      <CancelButton onClick={() => setOpen(false)} disabled={loading} />
      <Button
        onClick={() => handleUpdate()}
        text={t(TranslationKey.update).singular.upper}
        loading={loading}
        disabled={!input.validate() || !input.hasChanges(undefined)}
      />
    </div>
  );

  return (
    <ActionModal
      title={t(TranslationKey.binConstraintUpdate).singular.upper}
      open={open}
      setOpen={setOpen}
      footer={footer}
    >
      <BinConstraintInfoPane input={input} setInput={setInput} />
    </ActionModal>
  );
}
